const resolveDefaultBaseUrl = () => {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}

	const DEFAULT_DEV_API_URL = 'http://localhost:5000';

	if (typeof window !== 'undefined' && window.location) {
		const { hostname, port, origin } = window.location;
		const isReactDevServer = (hostname === 'localhost' || hostname === '127.0.0.1') && port === '3000';
		if (isReactDevServer) {
			return DEFAULT_DEV_API_URL;
		}
		return origin;
	}

	return DEFAULT_DEV_API_URL;
};

const API_BASE_URL = resolveDefaultBaseUrl().replace(/\/api$/, '').replace(/\/$/, '');

export default API_BASE_URL;
